export class ModelSummaryOee {
  constructor(
    public hash: string,
    public date: number,
    public availability: number,
    public performance: number,
    public quality: number,
    public oee: number,
    public oeeTrend: number,
    public current: boolean,
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-summary-oee.ts